module.exports = __webpack_public_path__ + "media/icons/color_bar-a805fa70.svg";